import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { useGetCustomersQuery } from '@/api/v2/customer';
import { CustomerDetailsContent } from '@/pageContents/customers/details/CustomerDetailsContent';
import { LoadingContainer } from '@starjack/shared-components';
import { useNotification } from '@starjack/features/notifications';

const CustomerDetails: PageWithLayout = () => {
    const { customerId } = useParams();
    const { data, isLoading: customerLoading } = useGetCustomersQuery({
        search: customerId as string,
    });
    const { addNotification } = useNotification();

    if (customerLoading) {
        return <LoadingContainer cover />;
    }

    const customer = data?.content?.[0];

    if (!customer) {
        addNotification({
            type: 'error',
            message: 'Fehler beim Laden des Kunden.',
        });
        return null;
    }

    return (
        <>
            <Helmet>
                <title>Kunde | {customer.lastname} | Starjack Backoffice</title>
            </Helmet>

            <CustomerDetailsContent customer={customer} />
        </>
    );
};

CustomerDetails.isProtected = true;
CustomerDetails.permissions = [];

CustomerDetails.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default CustomerDetails;
